// extracted by mini-css-extract-plugin
module.exports = {"root":"NavSearchButton_root__2DR8j","searchIcon":"NavSearchButton_searchIcon__20iOg"};